<p-card class="no-padding">
  <div class="flex justify-content-between">
    <strong class="mr-5" i18n>Nº de police</strong>
    {{ info.policyNumber }}
  </div>
  <div class="flex justify-content-between">
    <strong class="mr-5" i18n>Statut</strong>
    <div>
      <p-badge
        class="status-badge"
        [ngClass]="{
          'status-badge--green': info.status.value === status.APPROVED,
          'status-badge--red': info.status.value === status.REFUSED,
          'status-badge--yellow': info.status.value === status.PENDING_UNDERWRITER_ACTION,
          'status-badge--orange': info.status.value === status.PENDING_CLIENT_ACTION,
          'status-badge--blue': info.status.value === status.PENDING_EXTERNAL_ACTION,
          'status-badge--grey': info.status.value === status.CANCELED,
        }"></p-badge>
      {{ info.status.text }}
    </div>
  </div>
  @if (form) {
    <p-divider></p-divider>
    <div class="flex justify-content-between mt-3">
      <strong class="mr-5 align-self-center" i18n>Responsable</strong>
      <p-dropdown
        [options]="underwriterOptions"
        class="w-18rem"
        i18n-placeholder
        placeholder="Choisir"
        [formControl]="form"
        optionLabel="name"
        optionValue="value"></p-dropdown>
    </div>
  }
</p-card>
